import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./NewsVisualizationAudiovisual.css";

import Loading from "../../../components/Loading/Loading";
import Message from "../../../components/Message/Message";
import { fetchClientClippingDetail } from "../../../services/api/fetchClipping";
import NewsDataRow from "../../../components/NewsDataRow/NewsDataRow";
import TextPanel from "../../../components/TextPanel/TextPanel";
import ActionsButtons from "../../../components/ActionsButtons/ActionsButtons";
import Player from "../../../components/Player/Player";
import ActionIconButton from "../../../components/ActionIconButton/ActionIconButton";

import { ReactComponent as MediaIcon } from "../../../assets/icons/filter_media_type_icon.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/filter_period_icon.svg";
import { ReactComponent as SourceIcon } from "../../../assets/icons/filter_source_icon.svg";
import { ReactComponent as CategoryIcon } from "../../../assets/icons/filter_category_icon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/download_icon.svg";

function NewsVisualizationAudiovisual() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [message, setMessage] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadDetail = async () => {
      try {
        setIsLoading(true);
        const res = await fetchClientClippingDetail(id);
        setData(res);
      } catch (err) {
        console.error("Erro ao carregar detalhe:", err);
        setMessage({
          type: "error",
          text: "Não foi possível carregar a notícia.",
        });
      } finally {
        setIsLoading(false);
      }
    };
    if (id) loadDetail();
  }, [id]);

  if (isLoading) return <Loading />;
  if (!data)
    return (
      <div className="container-news-visualization-audiovisual">
        <p>Nenhuma notícia encontrada.</p>
      </div>
    );

  const handleBack = () => navigate(-1);

  const getFileExtension = (url) => {
    try {
      const ext = url.split('.').pop().split(/\#|\?/)[0];
      return ext ? `.${ext}` : '';
    } catch {
      return '';
    }
  };

    const forceDownload = async (url) => {
    try {
      setIsDownloading(true);
      setMessage(null);

      const finalUrl = url.startsWith("http")
        ? url
        : `${process.env.REACT_APP_API_URL}${url.replace(/^\/+/, "")}`;

      const response = await fetch(finalUrl);
      if (!response.ok) throw new Error("Erro ao baixar o arquivo.");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      const filename = `clipping`;
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);

      setMessage({ type: "success", text: "Download concluído com sucesso!" });
    } catch (err) {
      console.error("Erro ao forçar download:", err);
      setMessage({ type: "error", text: "Erro ao baixar o vídeo. Tente novamente." });
    } finally {
      setIsDownloading(false);

      setTimeout(() => setMessage(null), 5000);
    }
  };

  return (
    <div className="container-news-visualization-audiovisual">
      <h1 className="title-news-visualization-audiovisual">{data.title}</h1>

      <NewsDataRow
        title="Dados:"
        items={[
          {
            icon: MediaIcon,
            text: data?.source_detail?.source_type?.toUpperCase() || "—",
          },
          { icon: CalendarIcon, text: data?.publish_date || "—" },
          {
            icon: SourceIcon,
            text: `${data?.source_detail?.name || ""} ${
              data?.source_detail?.city
                ? `- ${data.source_detail.city.name} / ${data.source_detail.city.state}`
                : ""
            }`,
          },
          {
            icon: CategoryIcon,
            list: (data?.categories || [])
              .map((c) => c?.name?.trim())
              .filter(Boolean),
            tooltipTitle: "Categorias",
          },
        ]}
      />

      <div className="media-and-content-news-audiovisual">
          <Player
            link={
              data.stream_url.startsWith("http")
                ? data.stream_url
                : `${process.env.REACT_APP_API_URL}${data.stream_url.replace(/^\/+/, "")}`
            }
            isModalOpen={true}
            width="100%"
            height="500px"
            borderRadius="12px"
          />

        <div className="text-panel-wrapper">
          <TextPanel
            useTabs
            width="100%"
            height={500}
            tabs={[
              { label: "Resumo", html: data?.resume || "<p>Sem resumo disponível.</p>" },
              { label: "Transcrição", html: data?.content_text || "<p>Sem transcrição disponível.</p>" },
            ]}
          />
        </div>
      </div>

      <ActionsButtons
        text="Voltar"
        onClick={handleBack}
        type="button"
        showCancel={false}
        showSecondary={false}
        showTertiary={false}
      />

      {data?.document && (
        <div className="player-download-button">
          <ActionIconButton
            icon={DownloadIcon}
            bgColor="#EDEFF0"
            tooltip="Baixar vídeo"
            tooltipPosition="right"
            onClick={() => forceDownload(data.document)}
          />
        </div>
      )}

      {isDownloading && <Loading />}
      {message && <Message type={message.type} message={message.text} />}
    </div>
  );
}

export default NewsVisualizationAudiovisual;
